import {useContext} from "react";
import QRCodeDetailsContext from "../../QRCodeDetailsContext";
import {Button, Group, Text} from "@mantine/core";
import {IconCreditCard} from "@tabler/icons-react";
import CardWrapper from "../../_utils/card/_utils/wrapper/CardWrapper";
import SmallBadgeContainer from "./small-badge/SmallBadgeContainer";

type SummaryCardProps = {};

/**
 * @author Kacper Faber
 * @since 0.1.8
 * @constructor
 */
function SummaryCard(_: SummaryCardProps) {
    /**
     * QRCodeDetailsContext
     * @author Kacper Faber
     * @since 0.1.8
     */
    const ctx = useContext(QRCodeDetailsContext);

    /**
     * Throws 'Not implemented' error.
     * @throws Error
     * @author Kacper Faber
     * @since 0.1.8
     */
    const notImplemented = () => {
        throw new Error("Not implemented");
    }

    return (
        <CardWrapper>
            <Group justify="right">
                <Button
                    children="EDYTUJ"
                    variant="subtle"
                    c="rgba(4, 116, 205, 200)"
                    fw="bold"
                    radius="md"
                    onClick={notImplemented}
                />
            </Group>

            <Group gap="xs">
                <IconCreditCard
                    color="rgba(83, 103, 140, 100)"
                />

                <Text
                    c="rgba(83, 103, 140, 100)"
                    fw="bold"
                    size="sm"
                    children="VCARD PLUS"
                />
            </Group>

            <Text
                mt="md"
                c="black"
                children={ctx.qrCode?.name}
                size="1.75rem"
                fw="bold"
            />

            <SmallBadgeContainer
                mt="xl"
            />
        </CardWrapper>
    );
}

export default SummaryCard;

// TODO: SummaryCard.tsx
//  Implement Edit button
//  Add more buttons
//  Improve design.